import { useUppy } from 'Provider/UppyProvider.tsx'
import { useGetSamplePoolSelector } from '../../Flux/Selector/index.js'

export const UploadedFileList = () => {
  const { meta, files } = useUppy()
  const samplePools = useGetSamplePoolSelector()

  if (samplePools === "LOADING" || !meta || !files || !files.byPool[meta.poolId] || files.byPool[meta.poolId] === 'LOADING') {
    return null
  }

  const currentPool = samplePools.find((p) => p.id === meta.poolId)
  const mergedFileIds = new Set<string>(
    currentPool
      ? [
        ...currentPool.samples,
        ...currentPool.negativeControls,
      ].flatMap((sample) => [sample.forwardFileId, sample.reverseFileId].filter(x => x !== null && x !== undefined))
      : []
  )

  const poolFiles = files.byPool[meta.poolId]

  return (
    <div className="mt-4 max-h-[50vh] flex flex-col grow border-t p-2">
      <h3 className="text-md font-semibold mb-2">Files in current pool ({poolFiles != "LOADING" ? poolFiles.length : "LOADING"})</h3>
      <div className="grow overflow-y-auto">
      {poolFiles != "LOADING" && poolFiles.map((file) => {
        const isMerged = mergedFileIds.has(file.id)
        return (
          <div key={file.id} className="flex justify-between items-center py-1 border-b last:border-b-0">
            <span className="truncate text-sm">{file.fileName}</span>
            {isMerged ? (
              <span className="text-xs text-green-600">Merged</span>
            ) : (
              <span className="text-xs text-red-600">Unmerged</span>
            )}
          </div>
        )
      })}
      </div>
    </div>
  )
}
